"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.activateNextItem = void 0;
var activateNextItem = exports.activateNextItem = function activateNextItem(metas, next) {
  var setActivated = metas.setActivated,
    nextItem = metas.nextItem;
  setActivated === null || setActivated === void 0 || setActivated(nextItem !== null && nextItem !== void 0 ? nextItem : null);
  next(metas);
};